import type { DashboardItem } from 'src/types/dashboard'
import WidgetView from '@components/GridLayout/WidgetView/WidgetView'

import './DashboardGrid.css'

interface DashboardGridProps {
  items: DashboardItem[]
}

export default function DashboardGrid({ items }: DashboardGridProps) {
  return (
    <div id="dashboard-grid">
      {items.map((item) => (
        <div
          key={item.itemId}
          className="dashboard-grid-cell"
          style={{ gridColumn: `span ${item.width}` }}
        >
          <WidgetView item={item} />
        </div>
      ))}
    </div>
  )
}
